import gql from 'graphql-tag';

const SendInvoiceEmail = gql`
  mutation SendInvoiceEmail($input: SendInvoiceEmailInput!) {
    sendInvoiceEmail(input: $input) {
      success
      error {
        code
        message
        debug
      }
    }
  }
`;

export default SendInvoiceEmail;
